import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setMeterModalData } from '../store/actions/housingStockActions';

const useChangeMeterModalVisible = () => {
  const dispatch = useDispatch();

  const open = useCallback(
    (data) => {
      dispatch(setMeterModalData(data));
    },
    [dispatch]
  );

  const close = useCallback(() => {
    dispatch(setMeterModalData(null));
  }, [dispatch]);

  return { open, close };
};

export default useChangeMeterModalVisible;
